
(function ($, document) {

    $(document).ready(function () {
        var $cmsContentFirstChild = $('.highlight-intro').find('> :first-child');
        if ($cmsContentFirstChild.is('p')) {
            $cmsContentFirstChild.addClass("summary");
        }
        else {
            $('.highlight-intro').contents().first().wrap("<span class='summary'>");
        }
    });


})(jQuery, document);